// List of slugs that correspond to the sections as they are in the Aggregate API (keep in alphabetical order).
// prettier-ignore
const CATEGORY_SLUGS= {
    2017: "canada-2017",
    "2017/canadathestoryofus/csou-episodes": "canada-the-story-of-us-episodes",
    "2017/nye": "nye",
    "2017/whatsyourstory": "whats-your-story",
    archives: "cbc-archives",
    "archives/arts": "arts-entertainment",
    "archives/history": "cbc-archives-history",
    "archives/sports": "cbc-archives-sports",
    arts: "arts",
    "arts/watch": "arts-watch",
    "arts/read": "arts-read",
    "arts/canadianscreenawards": "canadian-screen-awards",
    "arts/insurgenceresurgence": "insurgence-resurgence",
    "arts/secretpath": "secret-path",
    "arts/arts-watch-on-gem": "empty-category",
    "arts/artuncontained": "art-uncontained",
    "arts/beingblackincanada": "arts",
    books: "books",
    "books/canadawrites": "canada-writes",
    "books/literaryprizes": "literary-prizes",
    "books/readinglists": "reading-lists",
    "books/ggbooks": "governor-generals-literary-awards",
    "books/gillerprize": "scotiabank-giller-prize",
    "books/kids": "td-kids-books-corner",
    "books/transmission": "books-transmission",
    "books/beingblackincanada": "books",
    cape: "cape", // CBC AbiliCrew Placements for Exellence Program
    comedy: "comedy",
    // We use category slug "empty-category" (category ID 140) when we only want to fetch pubqueue content from the aggregate api
    // (slug "empty-category" returns an empty array of content).
    "comedy/instagram": "empty-category",
    cree: "",
    documentaries: "documentaries",
    "documentaries/specials": "documentaries-special",
    "documentaries/features": "empty-category",
    "documentaries/brief-but-spectacular": "empty-category",
    "documentaries/the-oland-murder": "the-oland-murder",
    "documentaries/hotdocsoncbc": "hot-docs-at-home",
    "documentaries/goodpeople": "docs-good-people",
    "documentaries/enslaved": "docs-enslaved",
    homepage: "homepage",
    "homepage/featured": "empty-category",
    "homepage/gem": "empty-category",
    "homepage/paralympics": "empty-category",
    "learning-english": "learning-english",
    "learning-english/level-1": "empty-category", // Categories doesn't exist in API
    "learning-english/level-2": "empty-category", // Categories doesn't exist in API
    "learning-english/past-lessons": "empty-category", // Categories doesn't exist in API
    "learning-english/past-lessons/calgary": "empty-category", // Categories doesn't exist in API
    "learning-english/past-lessons/edmonton": "empty-category", // Categories doesn't exist in API
    life: "life",
    "life/culture": "culture",
    "life/food": "food",
    "life/giveaways": "giveaways",
    "life/greatcanadianbakingshow/bakers": "gcbs-bakers",
    "life/greatcanadianbakingshow/recipes": "gcbs-recipes-and-tips",
    "life/greatcanadianbakingshow/about": "gcbs-about",
    "life/jamieoliver": "life-jamie-oliver",
    "life/jamieoliver/recipes": "life-jamie-oliver-recipes",
    "life/jamieoliver/watch": "life-jamie-oliver-watch",
    "life/hellospring": "life-hello-spring",
    "life/hellospring/hellospring-livestream": "life-live-nature-streams",
    "life/hellospring/springscenes": "life-scenes-from-spring",
    "life/hellospring/showusyourspring": "life-show-us-your-spring",
    "life/hellospring/swimlane": "empty-category",
    "life/holiday": "holiday",
    "life/holiday/cbcgives": "cbc-gives",
    "life/home": "home",
    "life/work-money": "work-money",
    "life/pets": "pets",
    "life/style": "style",
    "life/travel": "travel",
    "life/video": "life-video",
    "life/wellness": "wellness",
    "life/fridgewars": "fridge-wars",
    "life/backintimeforwinter": "back-in-time-for-winter",
    "meta/hiddentestpage": "testing",
    music: "music",
    "music/firstplaylive": "music",
    "music/events": "music",
    "music/events/searchlight": "music",
    "music/events/festival": "music",
    "music/events/canadian-music-class-challenge": "music",
    "music/events/polaris": "music",
    "music/events/firstplaylive": "music",
    "music/explore": "music-explore",
    "music/junos": "junos",
    "music/junos/watch": "junos-archives",
    "music/junos/watch/video": "junos-watch-video",
    "music/junos/features": "junos-features",
    "music/junos/schedule": "junos-lists",
    "music/junos/news": "junos-news",
    "music/junos/sessions": "junos-sessions",
    news: "news",
    "news/canada": "empty-category",
    "news/canada/british-columbia": "empty-category",
    "news/canada/british-columbia/swimlane": "empty-category",
    "news/canada/british-columbia/community": "empty-category",
    "news/canada/british-columbia/video": "empty-category",
    "news/canada/new-brunswick/video": "empty-category",
    "news/canada/ottawa/video": "empty-category",
    "news/canada/manitoba/video": "empty-category",
    "news/canada/montreal/video": "empty-category",
    "news/canada/nova-scotia/video": "empty-category",
    "news/canada/windsor/video": "empty-category",
    "news/canada/saskatchewan/video": "empty-category",
    "news/canada/saskatoon/video": "empty-category",
    "news/canada/edmonton/video": "empty-category",
    "news/canada/newfoundland-labrador/video": "empty-category",
    "news/canada/prince-edward-island/video": "empty-category",
    "news/canada/thunder-bay/video": "empty-category",
    "news/canada/calgary": "empty-category",
    "news/canada/calgary/video": "empty-category",
    "news/canada/calgary/swimlane": "empty-category",
    "news/canada/calgary/community": "empty-category",
    "news/canada/edmonton": "empty-category",
    "news/canada/edmonton/swimlane": "empty-category",
    "news/canada/edmonton/community": "empty-category",
    "news/canada/hamilton": "empty-category",
    "news/canada/hamilton/swimlane": "empty-category",
    "news/canada/hamilton/video": "empty-category",
    "news/canada/kamloops": "empty-category",
    "news/canada/kitchener-waterloo": "empty-category",
    "news/canada/kitchener-waterloo/swimlane": "empty-category",
    "news/canada/kitchener-waterloo/video": "empty-category",
    "news/canada/london": "empty-category",
    "news/canada/london/swimlane": "empty-category",
    "news/canada/london/southwestsounds": "empty-category",
    "news/canada/london/video": "empty-category",
    "news/canada/manitoba": "empty-category",
    "news/canada/manitoba/swimlane": "empty-category",
    "news/canada/manitoba/community": "empty-category",
    "news/canada/montreal": "empty-category",
    "news/canada/montreal/quebecvotes2018": "empty-category",
    "news/canada/montreal/swimlane": "empty-category",
    "news/canada/montreal/community": "empty-category",
    "news/canada/new-brunswick": "empty-category",
    "news/canada/new-brunswick/nbvotes2018": "empty-category",
    "news/canada/new-brunswick/swimlane": "empty-category",
    "news/canada/new-brunswick/community": "empty-category",
    "news/canada/newfoundland-labrador": "empty-category",
    "news/canada/newfoundland-labrador/swimlane": "empty-category",
    "news/canada/newfoundland-labrador/community": "empty-category",
    "news/canada/north": "empty-category",
    "news/canada/north/swimlane": "empty-category",
    "news/canada/north/community": "empty-category",
    "news/canada/north/video": "empty-category",
    "news/canada/nova-scotia": "empty-category",
    "news/canada/nova-scotia/swimlane": "empty-category",
    "news/canada/nova-scotia/community": "empty-category",
    "news/canada/ottawa": "empty-category",
    "news/canada/ottawa/swimlane": "empty-category",
    "news/canada/ottawa/community": "empty-category",
    "news/canada/prince-edward-island": "empty-category",
    "news/canada/prince-edward-island/swimlane": "empty-category",
    "news/canada/prince-edward-island/community": "empty-category",
    "news/canada/saskatchewan": "empty-category",
    "news/canada/saskatchewan/swimlane": "empty-category",
    "news/canada/saskatchewan/community": "empty-category",
    "news/canada/saskatoon": "empty-category",
    "news/canada/saskatoon/swimlane": "empty-category",
    "news/canada/saskatoon/community": "empty-category",
    "news/canada/sudbury": "empty-category",
    "news/canada/sudbury/swimlane": "empty-category",
    "news/canada/sudbury/video": "empty-category",
    "news/canada/thunder-bay": "empty-category",
    "news/canada/thunder-bay/swimlane": "empty-category",
    "news/canada/toronto": "empty-category",
    "news/canada/toronto/swimlane": "empty-category",
    "news/canada/toronto/community": "empty-category",
    "news/canada/toronto/video": "empty-category",
    "news/canada/windsor": "empty-category",
    "news/canada/windsor/swimlane": "empty-category",
    "news/canada/manitoba/video-test": "empty-category",
    "news/canada/british-columbia/video-test": "empty-category",
    "news/canada/ottawa/video-test": "empty-category",
    "news/canada/nova-scotia/video-test": "empty-category",
    "news/canada/calgary/video-test": "empty-category",
    "news/canada/new-brunswick/video-test": "empty-category",
    "news/canada/saskatchewan/video-test": "empty-category",
    "news/canada/edmonton/video-test": "empty-category",
    "news/canada/montreal/video-test": "empty-category",
    "news/canada/newfoundland-labrador/video-test": "empty-category",
    "news/canada/windsor/video-test": "empty-category",
    "news/canada/toronto/video-test": "empty-category",
    "news/canada/saskatoon/video-test": "empty-category",
    "news/canada/london/video-test": "empty-category",
    "news/canada/thunder-bay/video-test": "empty-category",
    "news/canada/prince-edward-island/video-test": "empty-category",
    "news/canada/north/video-test": "empty-category",
    "news/canada/kitchener-waterloo/video-test": "empty-category",
    "news/canada/sudbury/video-test": "empty-category",
    "news/canada/hamilton/video-test": "empty-category",
    "news/canada/beingblackincanada/all": "empty-category",
    "news/canada/beingblackincanada/gem": "empty-category",
    "news/covid-19/featured": "empty-category",
    "news/covid-19/coping-with-covid-19": "empty-category",
    "news/covid-19/international-news": "world",
    "news/covid-19/fact-check": "",
    "news/covid-19/economy-and-finance": "",
    "news/covid-19/stories-of-hope": "",
    "news/covid-19/lives-remembered": "",
    "news/editorsblog": "empty-category",
    "news/elections/albertavotes2019": "empty-category",
    "news/elections/peivotes2019": "empty-category",
    "news/elections/nlvotes2019": "empty-category",
    "news/elections/nwtvotes2019": "empty-category",
    "news/elections/topstories": "empty-category",
    "news/elections/utilities": "empty-category",
    "news/investigates": "empty-category",
    "news/opinion": "empty-category",
    "news/gopublic": "empty-category",
    "news/joandonaldsonscholars": "empty-category",
    radio: "radio",
    "radio/podcasts": "podcasts",
    "radio/sks/transcripts": "someone-knows-something-transcripts",
    "radio/asithappens": "as-it-happens",
    "radio/thecurrent": "the-current",
    "radio/alone": "alone-a-love-story",
    "radio/becausenews": "because-news",
    "radio/checkup": "cross-country-checkup",
    "radio/costofliving": "radio-cost-of-living",
    "radio/day6": "day-6",
    "radio/docmakers": "the-docmakers",
    "radio/docproject": "the-doc-project",
    "radio/frontburner": "front-burner",
    "radio/ideas": "ideas",
    "radio/laughoutloud": "laugh-out-loud",
    "radio/nowornever": "now-or-never",
    "radio/outintheopen": "out-in-the-open",
    "radio/podcastnews": "podcast-news",
    "radio/podcastplaylist": "podcast-playlist",
    "radio/recall": "radio-recall",
    "radio/secretlifeofcanada": "the-secret-life-of-canada",
    "radio/spark": "spark",
    "radio/taiaskswhy": "tai-asks-why",
    "radio/tapestry": "tapestry",
    "radio/thedebaters": "the-debaters",
    "radio/thehouse": "the-house",
    "radio/thenextchapter": "the-next-chapter",
    "radio/thesundayedition": "sunday-edition",
    "radio/sunday": "sunday-edition",
    "radio/uncover": "uncover",
    "radio/undertheinfluence": "under-the-influence",
    "radio/unreserved": "unreserved",
    "radio/whatonearth": "radio-what-on-earth",
    "radio/whitecoat": "white-coat-black-art",
    "radio/writersandcompany": "writers-and-company",
    sports: "sports",
    "sports/baseball/mlb": "mlb",
    "sports/basketball/nba": "nba",
    "sports/basketball/cebl": "cebl",
    "sports/calgarystampede": "calgary-stampede",
    "sports/canada-150": "sports-canada-150",
    "sports/equestrian": "empty-category",
    "sports/football/cfl": "cfl",
    "sports/football/nfl": "nfl",
    "sports/golf": "golf",
    "sports/hockey/nhl": "nhl",
    "sports/iwd": "international-womens-day",
    "sports/olympics": "road-to-the-olympic-games",
    "sports/olympics/summer/highlights": "empty-category",
    "sports/olympics/winter/alpine-skiing": "alpine-skiing",
    "sports/olympics/summer/aquatics": "aquatics",
    "sports/olympics/winter/curling": "curling",
    "sports/olympics/summer/cycling": "cycling",
    "sports/olympics/winter/figure-skating": "figure-skating",
    "sports/olympics/winter/freestyle-skiing": "freestyle-skiing",
    "sports/olympics/summer/gymnastics": "gymnastics",
    "sports/olympics/promo": "rttog-promos",
    "sports/olympics/winter/sliding": "sliding",
    "sports/olympics/winter/snowboard": "snowboard",
    "sports/olympics/winter/speed-skating": "speed-skating",
    "sports/olympics/summer/trackandfield": "track-and-field",
    "sports/olympics/summer/schedule": "olympics-broadcast-schedule",
    "sports/olympics/summer/medals": "olympics-summer-medals",
    "sports/olympics/winter/volleyball": "volleyball",
    "sports/olympics/summer/sports": "olympic-summer-sports-list",
    "sports/olympics/winter/sports": "olympic-winter-sports-list",
    "sports/paralympics": "paralympics",
    "sports/paralympics/strip": "empty-category",
    "sports/podcasts": "sports-podcasts",
    "sports/podcasts/hnic": "hnic-podcast",
    "sports/podcasts/players-own-voice": "player-s-own-voice",
    "sports/rugby": "rugby",
    "sports/soccer": "soccer",
    "sports/soccer/cpl": "soccer-cpl",
    "sports/soccer/mls": "soccer-mls",
    "sports/soccer/worldcup": "fifa-world-cup",
    "sports/tennis": "tennis",
    "sports/video": "",
    "sports/beingblackincanada": "empty-category",
    topstories: "empty-category",
    television: "television",
    "television/fromthevaults": "from-the-vaults",
    "television/arcticvets": "empty-category",
    "television/stillstanding": "still-standing",
    "television/stillstanding/about": "still-standing-about",
    "television/battleoftheblades": "battle-of-the-blades",
    "television/battleoftheblades/skaters": "battle-of-the-blades-skaters",
    "television/battleoftheblades/blades-performances": "battle-of-the-blades-performances",
    "television/battleoftheblades/mini-blades": "battle-of-the-blades-mini-blades",
    "television/watch": "television-watch",
    "television/familyfeud": "family-feud",
    "television/higharctichaulers": "high-arctic-haulers",
    "television/thedetectives": "tv-the-detectives",
    "television/higharctichaulers/ship": "high-arctic-haulers-ship",
    "television/higharctichaulers/shore": "high-arctic-haulers-shore",
    "television/whatreyouat": "tv-what-re-you-at",
    "television/anyonesgame": "empty-category",
    "television/raceagainstthetide": "empty-category",
    visualstories: "visual-stories",
};
export default CATEGORY_SLUGS;
